import ProductGrid from "./ProductGrid";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import formatPrismicData from "../../hocs/formatPrismicData";
import { withModel } from "../../data-providers/model";
import { findLowestProductPrice } from "src/common/utils/product";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import withCountry from "../../hocs/withCountry";
import withMedia from "src/client/js/view/hocs/withMediaQueries";
import { replaceTextWithValues } from "src/common/utils/text-replace";
import withState from "recompose/withState";
import withGlobalContent from "../../hocs/withGlobalContent";
import { isMarketingCard, addMarketingCardCode } from "./helpers";
import get from "lodash/get";

const remapItems = (items, products, countryModel, ageRangeLabels) =>
  items
    .filter(
      (item) =>
        isMarketingCard(item) || get(item, "product.main.productId", false)
    )
    .map((item) => {
      if (isMarketingCard(item)) {
        return {
          ...item,
          isMarketingCard: true,
          product: {
            ...item.product,
            ...addMarketingCardCode(item.product),
          },
        };
      }

      const priceObj = findLowestProductPrice(
        products,
        item.product.main.productId
      );

      const path =
        item.overrideUrl ||
        `/personalized-products/${item.product.productInformation.productSlug}`;

      const { minimumAge: minAge, maximumAge: maxAge } =
        item.product.productInformation;

      const ageRangeLabel = maxAge
        ? replaceTextWithValues(ageRangeLabels.range, { minAge, maxAge })
        : replaceTextWithValues(ageRangeLabels.min, { minAge });

      return {
        ...item,
        price: priceObj,
        ageRangeLabel,
        priceLabel: replaceTextWithValues(item.priceLabel || "From %{price}", {
          price: priceObj && priceObj.formatted,
        }),
        url: localiseUrlII(countryModel, path),
      };
    })
    .filter((item) => isMarketingCard(item) || item.price);

const enhance = compose(
  formatPrismicData,
  withModel,
  withCountry,
  withGlobalContent,
  withProps((props) => {
    const {
      eagleModel: { products },
      countryModel,
    } = props.model;

    const ageRangeLabels = {
      range: get(
        props,
        "globalContent.general.ageRangeLabel",
        "Ages %{minAge}-%{maxAge}"
      ),
      min: get(
        props,
        "globalContent.general.ageRangeLabelMinOnly",
        "Ages %{minAge}+"
      ),
    };

    return {
      ctaLabel: get(props, "globalContent.general.cardCtaLabel", ""),
      ctaCloseLabel: get(props, "globalContent.general.cardCtaCloseLabel", ""),
      products,
      items: remapItems(props.items, products, countryModel, ageRangeLabels),
    };
  }),
  withState("expandedId", "setExpandedId", (props) =>
    get(props, "expandedId", null)
  ),
  withMedia
);

export default enhance(ProductGrid);
